<template>
    <VJoyPanel>
        <template #panel-title>{{ $t('projectclient.quote.view.payment-details.title') }}</template>
        <template #panel-body>
            <VJoyHighlight level="info" accent>
                <p
                    v-html="
                        $t('projectclient.quote.view.payment-details.highlight', [
                            handleCurrency(estimatedMonthlyPayment(quote), quote.currencyCode, locale),
                        ])
                    "
                ></p>
            </VJoyHighlight>
            <ul class="payment-details__list">
                <li class="payment-details__list__item">
                    <VJoyIcon name="calendar" color="neutral-50" />
                    <p>
                        <VJoyText preset="primary-450" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.prepay-month-by-month.title') }} {{ ' ' }}
                        </VJoyText>
                        <VJoyText preset="primary-400" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.prepay-month-by-month.content') }}
                        </VJoyText>
                    </p>
                </li>
                <li class="payment-details__list__item">
                    <VJoyIcon name="wallet" color="neutral-50" />
                    <p>
                        <VJoyText preset="primary-450" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.adjusted-to-actual-work.title') }} {{ ' ' }}
                        </VJoyText>
                        <VJoyText preset="primary-400" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.adjusted-to-actual-work.content', [workUnitLabel]) }}
                        </VJoyText>
                    </p>
                </li>
                <li class="payment-details__list__item">
                    <VJoyIcon name="check-circle" color="neutral-50" />
                    <p>
                        <VJoyText preset="primary-450" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.project-termination.title') }} {{ ' ' }}
                        </VJoyText>
                        <VJoyText preset="primary-400" tag-name="span" class="payment-details__list__item__text">
                            {{ $t('projectclient.quote.view.payment-details.list.item.project-termination.content') }}
                        </VJoyText>
                    </p>
                </li>
            </ul>
        </template>
    </VJoyPanel>
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {useLocale, useTranslation} from '#imports';
    import {VJoyHighlight, VJoyIcon, VJoyPanel, VJoyText} from '@maltjoy/core-vue';
    import type {TimeAndMaterialsQuoteResource} from '@api';
    import {handleCurrency} from '~/common/utils';
    import {estimatedMonthlyPayment} from '../../utils';

    const props = defineProps<{
        quote: TimeAndMaterialsQuoteResource;
    }>();

    const {locale} = useLocale();
    const {t} = useTranslation();

    const workUnitLabel = computed(() =>
        t(`projectclient.quote.view.quote-details.time-based.work-rate.${props.quote.details.workRate.unit}`, {
            count: props.quote.details.estimatedTotalWorkAmount,
        }),
    );
</script>
<style lang="scss" scoped>
    .payment-details {
        &__list {
            margin-top: var(--joy-core-spacing-6);
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-6);
            list-style: none;
            padding: 0;

            &__item {
                display: flex;
                align-items: center;
                gap: var(--joy-core-spacing-3);

                &__text {
                    display: inline;
                }
            }
        }
    }
</style>
